const window = require('window');
const Backbone = require('backbone');
const dustjs = require('dustjs');
const _selectBoxDust = require('common/_select_box.dust');
require('bootstrap');
var SelectBoxView = Backbone.View.extend({
	initialize: function(options = {}) {
		this.isHandledClientSide = options.isHandledClientSide;
		this.$optionButton = this.$('.js-option-button');
		this.onChange = options.onChange;

		this.model.set({
			overrideButtonStyle: options.overrideButtonStyle,
			showSelectedName: options.showSelectedName,
			isBuild: window.BCOM.theme.isBuild
		});

		this.listenTo(Backbone, 'body:click', this.hideOptions, this);
	},

	events: {
		'click .js-option-button': 'toggleOptionsVisibility',
		'click .js-option': 'selectOption'
	},

	/**
	 * Hide the options for this instance of the select box
	 */
	hideOptions: function() {
		this.$('.select-box').removeClass('visible-options');
	},

	/**
	 * The user has selected an option from the option drop down list.
	 * Adjust the model and re-render to reflect this then send a message telling what happened.
	 * @param {Object} event The click event
	 */
	selectOption: function(event) {
		const $selectedElement = $(event.currentTarget);
		this.$optionButton.button('loading');
		const value = $selectedElement.data('value');
		this.onChange && this.onChange(value);

		if ($selectedElement.attr('href') && !this.isHandledClientSide) {
			return;
		}
		event.preventDefault();
		// update the model
		this.model.set({
			selectedName: $selectedElement.text(),
			selectedValue: value
		});
		this.render();
		Backbone.trigger('selectBox:changed', this.model.toJSON());
		this.trigger('select:box:change', this.model.toJSON());
	},

	/**
	 * The user has clicked on the button in either the opened or closed state.
	 * Either way no change has taken place so we just toggle the class that
	 * hides and shows the other options.
	 */
	toggleOptionsVisibility: function(event) {
		// we stop the event here so that we can listen to body:click events
		// in order to close the options if need be
		event.stopPropagation();
		this.$('.select-box').toggleClass('visible-options');
	},

	/**
	 * Render out the select box based on the current data
	 */
	render: function() {
		dustjs.render(_selectBoxDust, this.model.toJSON(), (error, selectBoxMarkup) => {
			if (!error) {
				this.$el.html(selectBoxMarkup);
				this.$optionButton.button('reset');
			}
		});
	},

	/**
	 * Return the model's selected value
	 */
	getSelectedValue: function() {
		return this.model.get('selectedValue');
	}
});

module.exports = SelectBoxView;
